import './AppLoader.css';

export const AppLoader = () => (
    <div className="model-range-loader">
        <div className="model-range-loader-dot" />
        <div className="model-range-loader-dot" />
        <div className="model-range-loader-dot" />
    </div>
);
